import { render, staticRenderFns } from "./AppLayoutAskDetail.vue?vue&type=template&id=48689781&scoped=true&"
import script from "./AppLayoutAskDetail.vue?vue&type=script&lang=js&"
export * from "./AppLayoutAskDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutAskDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AppLayoutAskDetail.vue?vue&type=style&index=1&id=48689781&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48689781",
  null
  
)

export default component.exports